import { render } from "./PacientesProspectos.vue?vue&type=template&id=603c6113&scoped=true"
import script from "./PacientesProspectos.vue?vue&type=script&lang=js"
export * from "./PacientesProspectos.vue?vue&type=script&lang=js"

import "./PacientesProspectos.vue?vue&type=style&index=0&id=603c6113&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603c6113"]])

export default __exports__